import { jsx as l } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M8 1.948v.001l2.089 3.722 4.41 1.255-3.118 2.72.799 4.38L8 12.085l-4.18 1.943.798-4.38L1.5 6.924l4.41-1.253L8 1.95h-.001H8Z"
      }
    )
  }
);
export {
  t as StarFilled
};
